import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ChecklistReportLastActivePeriodStatusBase } from '../checklist-report-last-active-period-status-base';

@Component({
    selector: 'fi-checklist-report-last-active-period-status-grid-column',
    templateUrl: './checklist-report-last-active-period-status-grid-column.component.html',
    styleUrls: ['./checklist-report-last-active-period-status-grid-column.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ChecklistReportLastActivePeriodStatusGridColumnComponent extends ChecklistReportLastActivePeriodStatusBase {}
